export const ENVIRONMENT = {
    BASE_URL_API: 'https://qas.api.epago.pe',
    BASE_URL: 'https://qas.api.epago.pe',
};